var map = {
	"./enter/enter.vue": [
		"MBN1",
		10
	],
	"./mobile/about.vue": [
		"j1S8",
		0,
		12
	],
	"./mobile/join.vue": [
		"cBaM",
		0,
		5
	],
	"./mobile/judgeIndex.vue": [
		"uGHZ",
		0,
		7
	],
	"./mobile/question.vue": [
		"2w0Y",
		0,
		8
	],
	"./mobile/result.vue": [
		"S7Z6",
		0,
		1
	],
	"./mobile/training.vue": [
		"Moc+",
		0,
		13
	],
	"./pc/about.vue": [
		"9yO5",
		0,
		2
	],
	"./pc/join.vue": [
		"LVJN",
		0,
		9
	],
	"./pc/judgeIndex.vue": [
		"I+CC",
		0,
		4
	],
	"./pc/question.vue": [
		"5zX7",
		0,
		3
	],
	"./pc/result.vue": [
		"lccD",
		0,
		11
	],
	"./pc/training.vue": [
		"Ks5S",
		0,
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "A14c";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages lazy ^\.\/.*\.vue$
// module id = A14c
// module chunks = 15